<template>
  <div class="dacu-goods">
    <!-- 筛选条件 -->
    <div class="query-section">
      <div class="form-row">
        <!-- 管理员推广位选择 -->
        <div class="form-group" v-if="isAdmin">
          <label>推广位：</label>
          <el-select v-model="positionId" placeholder="请选择推广位" clearable>
            <el-option v-for="position in positions" :key="position.positionId"
              :label="`${position.positionId} ${position.positionName ? `(${position.positionName})` : '(---)'}`"
              :value="position.positionId" />
          </el-select>
        </div>

        <div class="form-group">
          <label>关键词：</label>
          <el-input v-model="queryForm.keyword" @input="onKeywordChange" placeholder="请输入商品关键词" clearable />
        </div>

        <div class="form-group">
          <label>类目：</label>
          <el-select v-model="queryForm.cid1" @change="onFilterChange" placeholder="请选择类目" clearable>
            <el-option v-for="category in cid1Options" :key="category.label" :label="category.label"
              :value="category.value" />
          </el-select>
        </div>

        <!-- <div class="form-group">
          <label>品牌:</label>
          <select v-model="queryForm.brandCode" @change="onFilterChange">
            <option v-for="brand in brandOptions" :key="brand.value" :value="brand.value">
              {{ brand.label }}
            </option>
          </select>
        </div> -->

        <div class="form-group" style="gap: 10px;">
          <button @click="loadGoods(true)" style="width: 100%;"> 刷新 </button>
          <button @click="onFilterChange" :disabled="loading" style="width: 100%;">
            {{ loading ? '查询中...' : '查询商品' }}
          </button>
        </div>
      </div>
    </div>

    <!-- 商品列表 -->
    <div class="results-section" ref="resultsSection" @scroll="handleScroll" v-if="goodsData?.length > 0">
      <div class="goods-list">
        <div class="goods-card" v-for="goods in goodsData" :key="goods.itemId" @click="openDetail(goods)"
          style="cursor: pointer;">

          <div style="display: flex;">
            <!-- 左侧商品图片区域 -->
            <div class="goods-left">
              <div class="goods-image-container">
                <img :src="goods.imageInfo?.imageList?.[0]?.url || '/placeholder.png'" :alt="goods.skuName"
                  class="goods-image" />
                <!-- 优惠券标签 -->
                <div class="coupon-overlay"
                  v-if="goods.purchasePriceInfo?.couponList && goods.purchasePriceInfo.couponList.length > 0">
                  <span class="coupon-badge">有券</span>
                </div>
              </div>
            </div>

            <!-- 右侧商品信息区域 -->
            <div class="goods-right">
              <!-- 商品标题 -->
              <div class="goods-header">
                <h3 class="goods-title" :title="goods.skuName"><span
                    style="font-size: 10px;background: #28a745;color: white;padding: 2px 4px;border-radius: 4px;"
                    v-if="goods.owner == 'g'">自营</span> {{ goods.skuName }}</h3>
              </div>

              <!-- 价格和佣金信息 -->
              <div class="price-commission-info">
                <div class="price-row">
                  <span class="price-label">到手价</span>
                  <div>
                    <span class="price-value" style="margin-left: 6px;">¥{{ calculateToHandPrice(goods) }}</span>
                  </div>
                </div>
                <div class="commission-row">
                  <span class="commission-label">佣金({{ formatPercent(getCommissionShare(goods)) }})</span>
                  <span class="commission-value">¥{{ formatPrice(getCommission(goods)) }}</span>
                </div>
              </div>

              <!-- 评价信息 -->
              <div class="review-info" style="display: flex;align-items: center;justify-content: space-between;">
                <span class="good-review-rate" v-if="goods.goodCommentsShare">
                  好评率 {{ goods.goodCommentsShare }}%
                </span>
                <span @click.stop="shareGoods(goods)"
                  style="background: #42b983;color: white;padding: 2px 4px;border-radius: 4px;font-size: 12px;font-weight: 500;cursor: pointer;transition: all 0.2s;">
                  <i class="icon-share"></i>分享赚 {{ formatPrice(getCommission(goods)) }}
                </span>
              </div>


            </div>

          </div>
        </div>
      </div>

      <!-- 加载状态 -->
      <div v-if="loading" class="loading">
        <div class="loading-spinner"></div>
        <p>正在加载商品...</p>
      </div>
      <!-- 错误状态 -->
      <div v-if="error" class="error">
        <p>{{ error }}</p>
        <button @click="loadGoods" class="retry-btn">重试</button>
      </div>
    </div>

    <!-- 回到顶部按钮 -->
    <div v-if="showBackToTop" class="back-to-top" @click="scrollToTop">
      <i class="el-icon-top"></i>
    </div>

    <!-- 分享赚钱弹窗 -->
    <ShareEarnModal :visible="showShareModal" :goods="selectedGoods" :positionId="positionId"
      @close="closeShareModal" />
  </div>
</template>

<script>
import { queryGoodsByEliteId, getCurrentUser, getAllPositions, getEnumValuesLiberayIds } from '@/utils/jdApi'
import ShareEarnModal from '@/components/ShareEarnModal.vue'

export default {
  name: 'ProductList',
  components: {
    ShareEarnModal
  },
  data() {
    return {
      loading: false,
      loadingMore: false,
      error: null,
      goodsData: [],
      allGoods: [], // 存储所有商品数据
      showBackToTop: false, // 控制回到顶部按钮显示
      showShareModal: false, // 控制分享弹窗显示
      selectedGoods: null, // 选中的商品信息
      positionId: null, // 管理员选择的推广位ID
      positions: [], // 推广位选项列表
      queryForm: {
        eliteId: 1001,
        // groupId: [1100660548, 1100664071, 1100664072, 1100664073, 1100664074, 1100664075, 1100664076, 1100664077],
        groupId: [],
        sortName: 'commission',
        pageIndex: 1,
        pageSize: 50,
        cid1: '',
        brandCode: '',
        keyword: ''
      },
      cid1Options: [
        { label: '全部', value: '' },
        // { label: '电视', value: '电视' },
        // { label: '冰箱', value: '冰箱' },
        // { label: '空调', value: '空调' },
        // { label: '热水器', value: '热水器' },
        // { label: '洗衣机', value: '洗衣机' },
        // { label: '清洁电器', value: '扫地机器人' },
        // { label: '烟灶', value: '油烟机、灶具' },
        // { label: '厨卫大电', value: '厨卫大电' },
      ],
      brandOptions: [
        { label: '全部品牌', value: '' },
        { label: '海信', value: '7888' },
        { label: '美的', value: '7889' },
        { label: '海尔', value: '7890' },
        { label: '格力', value: '7891' },
        { label: 'TCL', value: '7892' },
        { label: '创维', value: '7893' },
        { label: '长虹', value: '7894' },
      ],
      keywordTimer: null, // 关键词输入防抖定时器
      currentUser: null,
    }
  },
  computed: {
    isAdmin() {
      return this.currentUser && this.currentUser.role === 'ADMIN'
    },
  },
  mounted() {
    // 组件首次加载时执行
    this.currentUser = getCurrentUser()
    this.loadGoods() // 首次加载数据
    if (!this.isAdmin) {
      this.positionId = this.currentUser.positionId
    } else {
      this.loadPositions()
    }
  },
  activated() {
    // 组件从缓存中被激活时执行，不重新加载数据
    console.log('ProductList activated from cache')
  },
  methods: {
    loadPositions() {
      getAllPositions().then(res => {
        if (res && res.success) {
          this.positions = Array.isArray(res.data) ? res.data : []
          this.positionId = this.positions[0].positionId
        }
      }).catch(error => {
        console.error('加载推广位列表异常:', error)
      })
    },
    // 计算到手价
    calculateToHandPrice(goods) {
      try {
        // 安全获取补贴比例
        const subsidyTag = goods.skuTagList?.find(tag => tag.type === 6)
        const subsidyRatio = subsidyTag?.name?.match(/(\d+)%/) ?
          (parseInt(subsidyTag.name.match(/(\d+)%/)[1]) / 100) : 0
        // 安全获取优惠券折扣
        const isBestCoupon = goods.couponInfo?.couponList?.find(coupon => coupon.isBest == 1)?.discount || 0
        // 安全获取价格
        const basePrice = goods.priceInfo?.lowestPrice || goods.priceInfo?.price || 0
        // 计算到手价
        const toHandPrice = Math.max(0, basePrice * (1 - subsidyRatio) - isBestCoupon)
        return this.formatPrice(toHandPrice)
      } catch (error) {
        console.warn('计算到手价时出错:', error, goods)
        return '0.00'
      }
    },

    loadGoods(forceRefresh = false) {
      this.loadingMore = true
      this.loading = true

      // 只有在强制刷新或首次加载时才重置数据
      if (forceRefresh || !this.goodsData) {
        this.queryForm.pageIndex = 1 // 重置页码
        this.allGoods = [] // 清空之前的数据
        this.goodsData = null // 清空商品数据
      }

      this.error = null
      // 使用优化后的专用接口，只获取liberayIds字段，提高性能
      getEnumValuesLiberayIds().then(enumRes => {
        if (enumRes && enumRes.success && enumRes.data && enumRes.data.length > 0) {
          this.queryForm.groupId = enumRes.data[0].liberayIds || []
        } else {
          return this.$message.error('无法从枚举表加载 liberayIds，请先配置枚举值')
        }
        const { eliteId, pageIndex, pageSize, sortName, groupId, ownerUnionId } = this.queryForm
        queryGoodsByEliteId({ eliteId, pageIndex, pageSize, sortName, groupId, ownerUnionId }).then(response => {
          if (response && response.code === 200) {
            this.allGoods = response.data || []
            this.goodsData = response.data || []
            response.data.map(item => {
              const exists = this.cid1Options.some(option => option.label === item.categoryInfo.cid3Name)
              if (!exists) {
                this.cid1Options.push({
                  label: item.categoryInfo.cid3Name,
                  value: item.categoryInfo.cid3
                })
              }
            })
          } else {
            this.error = '查询失败'
          }
        }).catch(() => {
          this.error = '查询失败'
        }).finally(() => {
          this.loading = false
          this.loadingMore = false
        })
      })
    },
    // 筛选条件变化处理
    onFilterChange() {
      this.goodsData = this.allGoods.filter(item => {
        const matchCid1 = !this.queryForm.cid1 || item.categoryInfo.cid3 == this.queryForm.cid1
        const matchKeyword = !this.queryForm.keyword || item.skuName.includes(this.queryForm.keyword)
        return matchCid1 && matchKeyword
      });
    },
    // 关键词输入变化处理（防抖）
    onKeywordChange() {
      // 清除之前的定时器
      if (this.keywordTimer) {
        clearTimeout(this.keywordTimer)
      }

      // 设置新的定时器，500ms后执行搜索
      this.keywordTimer = setTimeout(() => {
        this.onFilterChange()
      }, 500)
    },
    // 处理滚动事件
    handleScroll(event) {
      const scrollContainer = event.target || this.$refs.resultsSection
      if (!scrollContainer) return

      const scrollTop = scrollContainer.scrollTop

      // 控制回到顶部按钮显示（滚动超过300px时显示）
      this.showBackToTop = scrollTop > 300
    },

    // 回到顶部
    scrollToTop() {
      const scrollContainer = this.$refs.resultsSection
      if (scrollContainer) {
        scrollContainer.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      }
    },

    formatPrice(price) {
      if (!price) return '0.00'
      return Number(price).toFixed(2)
    },

    formatPercent(percent) {
      if (!percent) return '0%'
      return Number(percent).toFixed(1) + '%'
    },

    copyGoodsLink(url) {
      if (!url) return

      try {
        navigator.clipboard.writeText(url)
        this.$message?.success?.('链接已复制到剪贴板')
      } catch (e) {
        // 降级方案
        const input = document.createElement('input')
        input.value = url
        document.body.appendChild(input)
        input.select()
        document.execCommand('copy')
        document.body.removeChild(input)
        this.$message?.success?.('链接已复制到剪贴板')
      }
    },

    openGoodsLink(url) {
      if (url) {
        window.open(url, '_blank')
      }
    },

    shareGoods(goods) {
      // 显示分享赚钱弹窗
      this.selectedGoods = goods
      this.showShareModal = true
    },

    // 打开商品详情
    openDetail(goods) {
      const detailData = {
        ...goods,
        promotionParams: {
          positionId: this.positionId, // 当前选择的推广位ID
        }
      }
      sessionStorage.setItem('productDetail', JSON.stringify(detailData))
      this.$router.push({ path: '/product-detail', query: { id: goods.itemId } })
    },

    // 关闭分享弹窗
    closeShareModal() {
      this.showShareModal = false
      this.selectedGoods = null
    },

    // 佣金比例(%)优先级: goods.commissionShare > goods.commissionInfo.commissionShare > 0
    getCommissionShare(goods) {
      if (goods && typeof goods.commissionShare === 'number') return goods.commissionShare
      if (goods && goods.commissionInfo && typeof goods.commissionInfo.commissionShare === 'number') {
        return goods.commissionInfo.commissionShare
      }
      if (goods && goods.promotionInfo && typeof goods.promotionInfo.commissionShare === 'number') {
        return goods.promotionInfo.commissionShare
      }
      return 0
    },

    // 佣金(¥)优先级: goods.couponCommission > goods.commissionInfo.commission > goods.commission > 0
    getCommission(goods) {
      if (goods && typeof goods.couponCommission === 'number') return goods.couponCommission
      if (goods && goods.commissionInfo && typeof goods.commissionInfo.commission === 'number') {
        return goods.commissionInfo.commission
      }
      if (goods && typeof goods.commission === 'number') return goods.commission
      return 0
    },

  }
}
</script>

<style scoped>
.dacu-goods {
  padding: 20px;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.query-section,
.results-section {
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background: #f9f9f9;
}

.results-section {
  flex: 1;
  overflow-y: auto;
}

.form-group {
  display: flex;
  width: 100%;
}

.form-group label {
  display: inline-block;
  width: 100px;
  font-weight: bold;
}

.form-group input,
.form-group select {
  width: 200px;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  gap: 10px;
}

button {
  background: #42b983;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 0px;
}

button:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.stats {
  background: #e8f5e8;
  padding: 15px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.stats p {
  margin: 5px 0;
  font-weight: bold;
}

.goods-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.goods-card {
  background: #fff;
  border: 1px solid #eee;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  min-height: 120px;
  transition: box-shadow 0.2s;
}

.goods-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}

/* 左侧商品图片区域 */
.goods-left {
  flex: 0 0 120px;
  position: relative;
  background: #f8f9fa;
}

.goods-image-container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.goods-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-tags {
  position: absolute;
  top: 8px;
  left: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.image-tag {
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  color: white;
}

.tag-type-4 {
  background: #ff6b35;
}

/* 超万人种草 */
.tag-type-5 {
  background: #28a745;
}

/* 京喜 */
.tag-type-8 {
  background: #fd7e14;
}

/* 超级补贴 */
.tag-type-12 {
  background: #17a2b8;
}

/* 7天无理由退货 */
.tag-type-14 {
  background: #6f42c1;
}

/* 同款高转化 */

.coupon-overlay {
  position: absolute;
  top: 0px;
  right: 0px;
}

.coupon-badge {
  background: #dc3545;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}

.main-price-tag {
  display: flex;
  align-items: center;
  gap: 8px;
}

.price-label {
  color: red;
  font-size: 18px;
  font-weight: bold;
}

.original-price {
  color: #ccc;
  font-size: 14px;
  text-decoration: line-through;
}

/* 右侧商品信息区域 */
.goods-right {
  flex: 1;
  padding: 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.price-commission-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.goods-title {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  color: #2c3e50;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-all;
}


.price-row,
.commission-row,
.subsidy-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
}

.price-label,
.commission-label,
.subsidy-label {
  font-size: 14px;
  color: #6c757d;
}

.price-value,
.commission-value,
.subsidy-value {
  font-size: 16px;
  font-weight: 600;
  color: #ff6b35;
}

.review-info {
  font-size: 12px;
  color: #6c757d;
}

.review-count,
.good-review-rate {
  margin-right: 12px;
}


.coupon-item {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 4px;
  padding: 2px 4px;
  font-size: 12px;
}

.coupon-amount {
  color: #856404;
  font-weight: 500;
}

.coupon-condition {
  color: #856404;
}

.goods-actions {
  display: flex;
  gap: 8px;
  margin-top: auto;
}

.action-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  margin-right: 8px;
}

.download-btn {
  background: #42b983;
  color: white;
}

.download-btn:hover {
  background: #369870;
}

.share-btn {
  background: #42b983;
  color: white;
}

.share-btn:hover {
  background: #369870;
}

.icon-download,
.icon-share {
  width: 12px;
  height: 12px;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .dacu-goods {
    padding: 10px;
  }

  .query-section,
  .results-section {
    padding: 10px;
  }

  .form-group label {
    width: auto;
    display: block;
    white-space: nowrap;
  }

  .form-group input,
  .form-group select {
    width: 100%;
    box-sizing: border-box;
  }

  .form-row {
    flex-direction: column;
  }

  .goods-card {
    flex-direction: column;
    min-height: auto;
  }

  .goods-left {
    width: 120px;
    height: 120px;
  }


  .goods-actions {
    flex-direction: row;
    gap: 8px;
  }

  .action-btn {
    width: 100%;
    justify-content: center;
    margin-right: 0;
  }
}

.goods-image {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.goods-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s;
}

.goods-card:hover .goods-image img {
  transform: scale(1.05);
}

.image-overlay {
  position: absolute;
  top: 8px;
  right: 8px;
}

.coupon-tag {
  background: #ff4757;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}

.goods-info {
  padding: 16px;
}

.goods-title {
  font-size: 14px;
  font-weight: 500;
  color: #2c3e50;
  line-height: 1.4;
  height: 2.8em;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.price-info {
  margin-bottom: 12px;
}

.price-main {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
}

.current-price {
  font-size: 18px;
  font-weight: 600;
  color: #e74c3c;
}

.original-price {
  font-size: 14px;
  color: #ccc;
  text-decoration: line-through;
}

.commission-info {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #7f8c8d;
}

.commission-rate {
  color: #27ae60;
  font-weight: 500;
}

.commission-amount {
  color: #e67e22;
  font-weight: 500;
}

.shop-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  font-size: 12px;
}

.shop-name {
  color: #34495e;
  font-weight: 500;
}

.shop-level {
  color: #f39c12;
  display: flex;
  align-items: center;
  gap: 2px;
}

.star {
  font-size: 10px;
}


.coupon-item {
  display: inline-block;
  background: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 4px;
  padding: 2px 4px;
  font-size: 11px;
}

.coupon-amount {
  color: #e17055;
  font-weight: 600;
}

.coupon-condition {
  color: #6c757d;
  margin-left: 4px;
}

.goods-tags {
  margin-bottom: 12px;
}

.tag {
  display: inline-block;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 10px;
  margin-right: 4px;
  margin-bottom: 4px;
}

.tag-return {
  background: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.goods-actions {
  display: flex;
  gap: 8px;
}

.action-btn {
  flex: 1;
  padding: 8px 12px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  transition: all 0.2s;
}

.copy-btn {
  background: #6c757d;
  color: white;
}

.copy-btn:hover {
  background: #5a6268;
}

.view-btn {
  background: #007bff;
  color: white;
}

.view-btn:hover {
  background: #0056b3;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin-top: 30px;
}

.page-btn {
  padding: 8px 16px;
  border: 1px solid #dee2e6;
  background: white;
  color: #495057;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
}

.page-btn:hover:not(:disabled) {
  background: #e9ecef;
}

.page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-info {
  color: #6c757d;
  font-size: 14px;
}

.loading {
  text-align: center;
  padding: 40px;
  color: #6c757d;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 16px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.error {
  text-align: center;
  padding: 40px;
  color: #dc3545;
}

.retry-btn {
  background: #dc3545;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  margin-top: 16px;
}

.retry-btn:hover {
  background: #c82333;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .dacu-goods {
    padding: 10px;
  }

  .filter-controls {
    flex-direction: column;
    align-items: stretch;
  }

  .filter-group {
    width: 100%;
  }

  .filter-group select {
    width: 100%;
  }

  .goods-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .goods-actions {
    flex-direction: row;
  }

  .action-btn {
    width: 100%;
  }
}

/* 加载更多样式 */
.loading-more {
  text-align: center;
  padding: 20px;
  color: #6c757d;
}

.loading-more .loading-spinner {
  width: 30px;
  height: 30px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #42b983;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 10px;
}

.no-more-data {
  text-align: center;
  padding: 20px;
  color: #999;
  font-size: 14px;
}

.no-more-data p {
  margin: 0;
}

/* 回到顶部按钮 */
.back-to-top {
  position: fixed;
  bottom: 60px;
  right: 14px;
  width: 35px;
  height: 35px;
  background: #42b983;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  z-index: 1000;
}

.back-to-top:hover {
  background: #369870;
  transform: translateY(-2px);
}

.back-to-top i {
  font-size: 20px;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .back-to-top {
    bottom: 20px;
    right: 20px;
    width: 40px;
    height: 40px;
  }

  .back-to-top i {
    font-size: 18px;
  }
}
</style>
